var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonRefund(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 260 285",
    style: {
      enableBackground: "new 0 0 260 285"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003663;}\n\t.st1{font-family:'MyriadPro-Regular';}\n\t.st2{font-size:175.5489px;}\n\t.st3{fill:none;stroke:#003663;stroke-width:30;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M234.1,136c-2.4-12.3-7-23.9-13.4-34.6c-6.3-10.5-14.3-19.8-23.8-27.6c-9.5-7.9-20.2-14.1-31.8-18.3 c-12-4.4-24.6-6.6-37.4-6.6s-25.5,2.2-37.4,6.6c-11.6,4.3-22.3,10.4-31.8,18.3c-9.5,7.8-17.5,17.1-23.8,27.6 c-2.3,3.8-4.4,7.8-6.2,11.8l-6.2-2.2c-3.2-1.2-6.5,1.5-6,4.9l4.4,30.9c0.5,3.6,4.8,5.1,7.5,2.7l23.2-21c2.5-2.3,1.7-6.4-1.5-7.6 l-6.4-2.3c1.4-3.1,3-6.1,4.8-9c5.4-9,12.2-16.9,20.3-23.6c8.1-6.7,17.3-12,27.1-15.6c10.2-3.8,21-5.7,31.9-5.7s21.7,1.9,31.9,5.7 c9.9,3.6,19,8.9,27.1,15.6c8.1,6.7,14.9,14.6,20.3,23.6c5.5,9.1,9.4,19.1,11.4,29.5c0.8,3.8,4.1,6.4,7.8,6.4c0.5,0,1.1-0.1,1.6-0.2 C232.1,144.5,234.9,140.3,234.1,136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.1,178.8c2.5,12.3,7,23.9,13.4,34.6c6.3,10.5,14.3,19.8,23.8,27.6c9.5,7.9,20.2,14.1,31.8,18.3 c12,4.4,24.6,6.6,37.4,6.6s25.5-2.2,37.4-6.6c11.6-4.3,22.3-10.4,31.8-18.3c9.5-7.8,17.5-17.1,23.8-27.6c2.3-3.8,4.4-7.8,6.2-11.8 l6.2,2.2c3.2,1.1,6.5-1.5,6-4.9l-4.4-30.9c-0.5-3.6-4.8-5.1-7.5-2.7l-23.2,21c-2.5,2.3-1.7,6.4,1.5,7.6l6.4,2.3 c-1.4,3.1-3,6.1-4.8,9c-5.4,9-12.2,16.9-20.3,23.6c-8.1,6.7-17.3,12-27.1,15.6c-10.2,3.8-20.9,5.6-31.9,5.6s-21.7-1.9-31.9-5.6 c-9.9-3.6-19-8.9-27.1-15.6c-8.1-6.7-14.9-14.6-20.3-23.6c-5.5-9.1-9.4-19.1-11.4-29.5c-0.8-3.8-4.1-6.4-7.8-6.4 c-0.5,0-1,0.1-1.6,0.2C23,170.2,20.2,174.4,21.1,178.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 73.082 214.5645)",
    className: "st0 st1 st2"
  }, "\u20AC")), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 28,
    y1: 247,
    x2: 235,
    y2: 61
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonRefund);
export default __webpack_public_path__ + "static/media/NonRefund.03d9889b0c3f78c2d5739090d73eafe3.svg";
export { ForwardRef as ReactComponent };